// NotificationHandler.js
import React, { useEffect, useContext } from 'react';
import { UserContext } from '../../context/UserContext';
import { messaging } from '../../firebase';
import { getToken, onMessage } from 'firebase/messaging';
import api from '../../Api';

const NotificationHandler = () => {
  const { user } = useContext(UserContext);

  useEffect(() => {
    // Non fare nulla se l'utente non è ancora caricato
    if (!user || !user.id) return;

    const requestPermission = async () => {
      const permission = await Notification.requestPermission();
      if (permission === 'granted') {
        try {
          const currentToken = await getToken(messaging, {
            vapidKey: 'BFFzU7d4oOg5gZ7EursogtiuFMOdI3DcjdOdQp2aAaWql0OD2dNbU85MKYgMzrJsdS2WTnCd0hn4k1iKfxpGWtU',
          });
          if (currentToken) {
            // Invia il token al backend
            api.post('/user/update-token', { userId: user.id, fcmToken: currentToken })
              .then(response => {
              })
              .catch(error => {
                console.error('Errore aggiornamento token:', error);
              });
          } else {
            console.warn('⚠️ Nessun token disponibile');
          }
        } catch (err) {
          console.error('❌ Errore nel recupero del token:', err);
        }
      }
    };

    requestPermission();

    // Gestione delle notifiche in foreground
    onMessage(messaging, (payload) => {
    
      if (Notification.permission === 'granted' && navigator.serviceWorker) {
        navigator.serviceWorker.getRegistration().then((reg) => {
          if (reg) {
            const { title, body, icon } = payload.notification;
    
            reg.showNotification(title, {
              body,
              icon: icon || '/logo.png',
              data: {
                url: '/',
              }
            });
          } else {
            console.warn("⚠️ Nessun service worker registrato");
          }
        });
      } else {
        console.warn("❌ Notification.permission non è 'granted' o manca service worker");
      }
    });
  }, [user]);

  return null;
};

export default NotificationHandler;
